export const TAKE = 10;

export const getPagesCount = (total: number | null | undefined): number => {
  if (!total) {
    return 0;
  }
  return Math.ceil(total / TAKE);
};
